import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'formatValue'
})
export class FormatValuePipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return '';

    if (typeof value === 'string') {
      const parsedDate = this.tryParseDate(value);
      if (parsedDate) {
        return this.formatDate(parsedDate);
      }
    }

    if (typeof value === 'number') {
      return new Intl.NumberFormat('ru-RU').format(value);
    }

    if (typeof value === 'boolean') {
      return value ? 'Да' : 'Нет';
    }

    return value;
  }

  private tryParseDate(value: string): Date | null {
    const datePatterns = [
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/, 
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/,
      /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}/ 
    ];

    const isDateString = datePatterns.some(pattern => pattern.test(value));
    if (!isDateString) return null;

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }
}